import axios from 'axios'

export default {
  async liqpayCheckout(payload) {
    return axios.post(`/payment/liqpay-checkout`, payload)
  },

  async liqpayCheckPaymentStatus(orderId) {
    return axios.get(`/payment/liqpay-check-payment-status/${orderId}`)
  }
}
